import React from "react";
import { useTheme } from "@mui/material";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCake } from "@fortawesome/free-solid-svg-icons";

const IconCake = ({ ...props }) => {
  const theme = useTheme();
  return (
    <FontAwesomeIcon
      icon={faCake}
      color={theme.palette.secondary.main}
      {...props}
    />
  );
};

export default IconCake;
